import { Component, Input, SimpleChanges, OnChanges, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-group-pages',
  templateUrl: './group-pages.component.html',
  styleUrls: ['./group-pages.component.scss']
})
export class GroupPagesComponent implements OnChanges {
  @Input() source: string = "";
  @Input() group: any = null;
  @Input() activePages:any[]=[]
  
  @Output() processPagesEvent= new EventEmitter<any>();
  @Output() groupMutated= new EventEmitter<any>();
  pages: any[] = [];


  areInputsValid(): boolean {
    return this.source !== "" && this.group && this.group.socialMedia;
  }

  anyPageInProcess(){
    return this.group.socialMedia?.some((p:any)=>
      this.activePages.find((pa:any)=>pa.id==p.id) && p.source==this.source
    )
  }
  isPageInProcess(page:any){
    
    return this.activePages.find((p:any)=>p.id==page.id)
  }
  
 ngOnChanges(changes: SimpleChanges) {
    if (changes['group'] && this.group?.socialMedia) {
      // ✅ Mutate in place so parent sees changes
      this.group.socialMedia.forEach((sm: any) => {
        if (!('isDownloading' in sm)) sm.isDownloading = false;
        if (!('isSynching' in sm)) sm.isSynching = false;
        if (!('isDone' in sm)) sm.isDone = false;
      });

      // ✅ Now safely filter the relevant pages for this source
      this.pages = this.group.socialMedia.filter(
        (p: any) => p.source === this.source
      );
    }
  }


  ngOnInit(){
    
    if(this.areInputsValid()){
      this.pages=this.group.socialMedia.filter((p:any)=>p.source==this.source).map((p:any)=>{return{...p,isFetching:false}})
    }
  }

  getPages(){
    if(this.areInputsValid()){
      return  this.group.socialMedia.filter((p:any)=>p.source==this.source).map((p:any)=>{return{...p,isFetching:false}})
    }
    return []
  }
  fetchPosts(pages:any){
    //emit fetch pages
    console.log(pages)
    const pageIds = Array.isArray(pages)?pages.map((p:any)=>p.id):[pages.id]
    console.log("processing pages",pageIds)
    if(pageIds.length==1){
      this.processPagesEvent.emit(pageIds)
    }
  }
  newPosts(page:any){
    if(page.isDownloading)return "--"
    return page.new || 0
  }
  updatedPosts(page:any){
    if(page.isDownloading)return "--"
    const postCount = page.source=="facebook" ||page.source=="instagram"? page.analytics[page.analytics.length-1].numberOfPublications:page.analytics?.numberOfPublications
    return page.updated || postCount || 0
  }
  totalPostsNew(){
    let total=0
    if(this.pages.length==0 )return "--"
    this.pages.forEach((p:any)=>{
      total+=this.newPosts(p)=="--"?0:this.newPosts(p)
    })
    return total
  }
  n(val:any){
    if (typeof val =='number')return val
    if (isNaN(Number(val))){
      return 0
    }
    return Number(val)
  }
   totalPostsUpdated(){
    let total=0
    if(this.pages.length==0)return "--"
    this.pages.forEach((p:any)=>{
      total+=this.updatedPosts(p)=="--"?0:this.updatedPosts(p)
    })
    return total
  }
}
